import { useState, useEffect, useCallback, useContext, useRef } from 'react';
import { CountContext } from '../Context/Allcontext';
import { useSelector } from "react-redux";
import ls from 'local-storage';

let socketInstance = null;
let isConnecting = false;
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 5;
let currentClientId = null;
let connectionId = null;
let activeSendFunction = null; 

const WebSocketCaller = () => {
    const [socket, setSocket] = useState(null);
    const [listeners, setListeners] = useState([]);
    const context = useContext(CountContext);
    const handleWebData = context?.handleWebData || (() => { });
    
    // Use ref to track component mount state
    const isMounted = useRef(true);
    const sellerDetailsRef = useRef(null);

    const sellerDetails = useSelector(state => state.LoginReducer.payload);
    const dealerData = useSelector(state => state.DealerReducer.payload);

    const [isLoggedIn, setIsLoggedIn] = useState(ls.get("islogedIn"));

    // Update ref when sellerDetails changes
    useEffect(() => {
        sellerDetailsRef.current = sellerDetails;
    }, [sellerDetails]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            if (socketInstance) {
                sendDisconnectMessage();
                socketInstance.close();
                socketInstance = null;
                activeSendFunction = null;
            }
        };

        const isUserLoggedIn = ls.get("islogedIn") === true;
        
        if (!sellerDetails || !sellerDetails.seller_id || !isUserLoggedIn) {
            setIsLoggedIn(false);
            if (socketInstance) {
                handleCloseWebSocket();
            }
            return;
        }
        
        setIsLoggedIn(true);

        // Only create connection if none exists and not currently connecting
        if (!socketInstance && !isConnecting) {
            console.log("Opening seller WebSocket connection...");
            openWebSocketConnection();
        } else if (socketInstance) {
            console.log("Reusing existing seller WebSocket connection");
            setSocket(socketInstance);
            activeSendFunction = createSendFunction(socketInstance);
        }

        window.addEventListener('beforeunload', handleBeforeUnload);
        
        isMounted.current = true;

        return () => {
            isMounted.current = false;
            window.removeEventListener('beforeunload', handleBeforeUnload);
            // Don't auto-close on unmount - let connection persist
        };
    }, [sellerDetails?.seller_id]); // Only when seller_id changes

    useEffect(() => {
        if (!isLoggedIn && socketInstance) {
            console.log("User not logged in, closing WebSocket");
            handleCloseWebSocket();
        }
    }, [isLoggedIn]);

    const getTimezone = () => {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    };

    const sendDisconnectMessage = () => {
        const currentSeller = sellerDetailsRef.current;
        if (socketInstance && socketInstance.readyState === WebSocket.OPEN && currentClientId && currentSeller) {
            try {
                const disconnectMsg = {
                    type: "disconnect",
                    clientId: currentClientId,
                    seller_id: currentSeller.seller_id,
                    action: "logout"
                };
                socketInstance.send(JSON.stringify(disconnectMsg));
                console.log("Disconnect message sent to server");
            } catch (error) {
                console.error("Error sending disconnect message:", error);
            }
        }
    };

    const createSendFunction = (socket) => {
        return (data) => {
            const currentSeller = sellerDetailsRef.current;
            const isUserLoggedIn = ls.get("islogedIn") === true;
            
            if (!isUserLoggedIn || !currentSeller || !currentSeller.seller_id) {
                console.warn("User not logged in or invalid seller, not sending WebSocket message");
                return false;
            }
            
            if (socket && socket.readyState === WebSocket.OPEN) {
                const messageWithMeta = {
                    ...data,
                    _connectionId: connectionId,
                    _timestamp: Date.now()
                };
                socket.send(JSON.stringify(messageWithMeta));
                console.log("Seller WebSocket message sent with connection ID:", connectionId);
                return true;
            } else {
                console.warn("Seller WebSocket is not open. Unable to send data. ReadyState:", socket?.readyState);
                return false;
            }
        };
    };

    const openWebSocketConnection = () => {
        const currentSeller = sellerDetailsRef.current;
        
        if (!currentSeller?.seller_id) {
            console.log("No seller details, skipping WebSocket connection");
            return;
        }
        
        const isUserLoggedIn = ls.get("islogedIn") === true;
        if (!isUserLoggedIn) {
            console.log("User not logged in, skipping WebSocket connection");
            return;
        }
        
        connectionId = `${currentSeller.seller_id}_${Date.now()}`;

        isConnecting = true;
        const wsUrl = `wss://ws-buyer.ur2ndlot.com:8080/urs2ndlot_Seller/v1/sellerid=${currentSeller.seller_id}/sellerdealerid=${currentSeller.seller_dealer_id}/sellertoken=${currentSeller.seller_token}/type=seller/timezone=${getTimezone()}/connectionId=${connectionId}`;

        console.log("Connecting to seller WebSocket:", wsUrl);

        socketInstance = new WebSocket(wsUrl);

        socketInstance.addEventListener('open', () => {
            console.log("Seller WebSocket connection opened");
            isConnecting = false;
            reconnectAttempts = 0;
            if (isMounted.current) {
                setSocket(socketInstance);
            } activeSendFunction = createSendFunction(socketInstance);
        });

        socketInstance.addEventListener('message', (event) => {
            try {
                const data = JSON.parse(event.data);
                console.log("Seller WebSocket message received:", data);
                
                if (data.type === "connection_established" && data.clientId) {
                    currentClientId = data.clientId;
                    console.log("Client ID assigned by server:", currentClientId);
                }
                
                let modelType = null;
                let responseData = data;

                if (Array.isArray(data) && data.length >= 2) {
                    modelType = data[data.length - 1];
                    responseData = data.slice(0, -1);
                    if (responseData.length === 1) {
                        responseData = responseData[0];
                    }
                } else if (data && data.model) {
                    modelType = data.model;
                    responseData = data;
                }

                console.log("Resolved modelType:", modelType);
                console.log("Response data:", responseData);
                
                // Only broadcast if component is still mounted
                if (isMounted.current) {
                    broadcast(data);
                     if (responseData !== data) {
                broadcast(responseData);
            }
                    switch (modelType) {
                        case "notificationDetails":
                        case "carDetails":
                        case "recentlyAddCarsfilter":
                        case "allCarsfilter":
                        case "recentlysoldcarsfilter":
                        case "counter_bid":
                            if (handleWebData && typeof handleWebData === 'function') {
                                handleWebData(data);
                            }
                            break;
                        case "cliendId":
                            console.log("Client ID received:", responseData);
                            break;
                        default:
                            if (data.success === true || (Array.isArray(data) && data[0]?.success === true)) {
                        console.log("Success response detected, passing to handler");
                        if (handleWebData && typeof handleWebData === 'function') {
                            handleWebData(data);
                        }
                    }
                    console.log("Unknown seller message type:", modelType);
                            break;
                    }
                }
            } catch (error) {
                console.error("Error processing WebSocket message:", error);
            }
        });

        socketInstance.addEventListener('error', (event) => {
            console.error('Seller WebSocket error:', event);
            isConnecting = false;
        });

        socketInstance.addEventListener('close', (event) => {
            console.log("Seller WebSocket connection closed", event);
            isConnecting = false;
            
            // Clear the active send function
            activeSendFunction = null;
            
            const isUserLoggedIn = ls.get("islogedIn") === true;
            const currentSellerCheck = sellerDetailsRef.current;
            const hasValidSeller = currentSellerCheck && currentSellerCheck.seller_id;
            
            if (isUserLoggedIn && hasValidSeller && reconnectAttempts < MAX_RECONNECT_ATTEMPTS && isMounted.current) {
                reconnectAttempts++;
                const delay = Math.min(1000 * Math.pow(2, reconnectAttempts), 30000);
                console.log(`Reconnecting in ${delay}ms (attempt ${reconnectAttempts}/${MAX_RECONNECT_ATTEMPTS})`);
                setTimeout(() => {
                    if (isMounted.current && !socketInstance && isUserLoggedIn && hasValidSeller) {
                        openWebSocketConnection();
                    }
                }, delay);
            } else {
                console.log("Not reconnecting - user logged out or invalid seller details");
                if (isMounted.current) {
                    setSocket(null);
                }
                socketInstance = null;
                currentClientId = null;
            }
            
            if (!isUserLoggedIn && isMounted.current) {
                setSocket(null);
                socketInstance = null;
                currentClientId = null;
            }
        });
    };

    const handleCloseWebSocket = () => {
        console.log("Manually closing WebSocket connection...");
        
        // Clear active send function first
        activeSendFunction = null;
        
        if (socketInstance && socketInstance.readyState === WebSocket.OPEN) {
            sendDisconnectMessage();
            
            setTimeout(() => {
                if (socketInstance) {
                    socketInstance.close();
                    socketInstance = null;
                    if (isMounted.current) {
                        setSocket(null);
                    }
                }
            }, 100);
        } else if (socketInstance) {
            socketInstance.close();
            socketInstance = null;
            if (isMounted.current) {
                setSocket(null);
            }
        }
        
        isConnecting = false;
        reconnectAttempts = 0;
        currentClientId = null;
        connectionId = null;
    };

    const broadcast = useCallback((data) => {
        if (isMounted.current) {
            listeners.forEach((listener) => listener(data));
        }
    }, [listeners]);

    const addListener = useCallback((listener) => {
        setListeners((prevListeners) => [...prevListeners, listener]);
    }, []);

    const removeListener = useCallback((listener) => {
        setListeners((prevListeners) => prevListeners.filter((l) => l !== listener));
    }, []);

    const send = useCallback((data) => {
    console.log("WebSocket send called with data:", data);
    
    const currentSeller = sellerDetailsRef.current;
    const isUserLoggedIn = ls.get("islogedIn") === true;
    
    if (!isUserLoggedIn || !currentSeller || !currentSeller.seller_id) {
        console.warn("User not logged in or invalid seller, not sending WebSocket message");
        return false;
    }
    
    if (socketInstance && socketInstance.readyState === WebSocket.OPEN) {
        const messageWithMeta = {
            ...data,
            _connectionId: connectionId,
            _timestamp: Date.now()
        };
        console.log("Sending WebSocket message:", messageWithMeta);
        socketInstance.send(JSON.stringify(messageWithMeta));
        console.log("Seller WebSocket message sent with connection ID:", connectionId);
        return true;
    } else {
        console.warn("Seller WebSocket is not open. ReadyState:", socketInstance?.readyState);
        return false;
    }
}, []);

    const getCurrentClientId = useCallback(() => currentClientId, []);

    return { 
        addListener, 
        removeListener, 
        send, 
        isConnected: socketInstance?.readyState === WebSocket.OPEN, 
        closeWebSocket: handleCloseWebSocket, 
        getCurrentClientId 
    };
};

export default WebSocketCaller;